/**
 * Product Card Variant Picker with Progressive Disclosure - FIXED VERSION
 * Desktop: Hover card to show first option list
 * Mobile: Tap plus icon to show first option list
 * Both: Progressive step-by-step variant selection with proper animations
 * Last step / QUICK ADD → add to cart
 */

(function() {
  'use strict';

  // Track global outside-click listener
  var npVariantOutsideListenerAttached = false;
  // Treat mobile as touch device OR small viewport (for variant UX)
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var isMobile = isTouchDevice || window.matchMedia('(max-width: 768px)').matches;

  // *** NEW: Swiper "mobile" breakpoint ONLY for default slide logic (≤ 1008px) ***
  var SLIDER_MOBILE_BREAKPOINT = 1008;
  function isSliderMobileViewport() {
    if (window.matchMedia) {
      return window.matchMedia('(max-width: ' + SLIDER_MOBILE_BREAKPOINT + 'px)').matches;
    }
    return window.innerWidth <= SLIDER_MOBILE_BREAKPOINT;
  }

  function safeJSONParse(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      console.error('Failed to parse variants JSON', e);
      return null;
    }
  }

  // Helper functions for option list visibility with proper animations
  function showOptionList(list) {
    if (!list) return;
    // Use requestAnimationFrame to ensure display:flex is set before transforms
    requestAnimationFrame(function() {
      list.style.display = 'flex';
      // Force reflow
      list.offsetHeight;
      list.style.transform = 'translateY(0)';
      list.style.opacity = '1';
      list.style.height = 'auto';
    });
  }

  function hideOptionList(list) {
    if (!list) return;
    list.style.transform = '';
    list.style.opacity = '';
    list.style.height = '';
    list.style.display = 'none';
  }

  function hideAllOptionLists(card) {
    var optionLists = card.querySelectorAll('.product-variant-picker-option');
    optionLists.forEach(function(list) {
      hideOptionList(list);
    });
  }

  function showFirstOptionList(card) {
    var firstList = card.querySelector('.product-variant-picker-option[data-option-index="0"]');
    if (!firstList) {
      firstList = card.querySelector('.product-variant-picker-option');
    }
    if (firstList) {
      showOptionList(firstList);
    }
  }

  function getNextOptionList(card, currentOptionIndex) {
    var nextIndex = currentOptionIndex + 1;
    return card.querySelector('.product-variant-picker-option[data-option-index="' + nextIndex + '"]');
  }

  function isAnyOptionListVisible(card) {
    var optionLists = card.querySelectorAll('.product-variant-picker-option');
    for (var i = 0; i < optionLists.length; i++) {
      if (optionLists[i].style.display === 'flex') {
        return true;
      }
    }
    return false;
  }

  // Find variant matching selected options
  function createVariantFinder(variants) {
    return function findVariantForSelections(selectedOpts) {
      if (!Array.isArray(selectedOpts) || !variants || !variants.length) return null;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var allMatch = true;

        for (var optIndex = 0; optIndex < selectedOpts.length; optIndex++) {
          var value = selectedOpts[optIndex];
          if (!value) {
            allMatch = false;
            break;
          }

          var variantOptionValue =
            optIndex === 0
              ? variant.option1
              : optIndex === 1
              ? variant.option2
              : variant.option3;

          if (variantOptionValue !== value) {
            allMatch = false;
            break;
          }
        }

        if (allMatch) return variant;
      }
      return null;
    };
  }

  // Add to cart via AJAX and open cart drawer / trigger events
  function ajaxAddToCart(variantId) {
    if (!variantId) return Promise.resolve(null);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) {
            throw new Error(data && data.description ? data.description : 'Failed to add to cart');
          }
          return data;
        });
      })
      .then(function(data) {
        // Update cart count
        return fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
            var cartCountEls = document.querySelectorAll('.cart-count,[data-cart-count]');
            cartCountEls.forEach(function(el) {
              el.textContent = count;
            });

            // Open / refresh cart drawer using theme events
            try {
              if (typeof document.dispatchEvent === 'function') {
                document.dispatchEvent(
                  new CustomEvent('dispatch:cart-drawer:open', {
                    detail: { opener: null }
                  })
                );
                document.dispatchEvent(
                  new CustomEvent('dispatch:cart-drawer:refresh')
                );
              } else if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
                window.CartDrawer.open();
              } else if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === 'function') {
                window.theme.cartDrawer.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
              }
            } catch (drawerErr) {
              console.warn('Cart drawer open error:', drawerErr);
            }

            return data;
          });
      })
      .catch(function(error) {
        console.error('Add to cart error:', error);
        try {
          alert('Unable to add item to cart. Please try again.');
        } catch (ignore) {}
        return null;
      });
  }

  // Initialize variant picker for a single product card
  function initVariantPicker(card) {
    if (!card) return;

    var swiperContainer = card.querySelector('.image-grid-gallery-new.swiper');
    var swiperInstance = null;

    /**
     * Initialize Swiper for product card gallery
     * (runs for ALL cards, even if there are no variants)
     */
    function initCardSwiper() {
      if (!swiperContainer) return;

      if (swiperContainer.dataset.npSwiperInitialized === 'true') {
        swiperInstance = swiperContainer.swiper || swiperContainer._npSwiper;
        return swiperInstance;
      }

      if (typeof Swiper === 'undefined') {
        console.warn('Swiper.js is not loaded. Product card slider will not work.');
        return null;
      }

      var totalSlides = swiperContainer.querySelectorAll('.swiper-slide').length;
      if (totalSlides <= 1) return null;

      var navPrev = swiperContainer.querySelector('.swiper-button-prev');
      var navNext = swiperContainer.querySelector('.swiper-button-next');

      // *** NEW: dynamic default slide index based on viewport ***
      // Desktop (> 1008px) => index 1, Mobile (≤ 1008px) => index 0
      var defaultSlideIndex = isSliderMobileViewport() ? 0 : 1;

      try {
        swiperInstance = new Swiper(swiperContainer, {
          loop: totalSlides > 1,
          loopAdditionalSlides: 2,
          slidesPerView: 1,
          spaceBetween: 5,
          speed: 600,
          initialSlide: defaultSlideIndex, // *** CHANGED from 1 ***
          allowSlidePrev: true,
          allowSlideNext: true,
          navigation: {
            nextEl: navNext,
            prevEl: navPrev
          },
          keyboard: { enabled: true },
          a11y: { enabled: true },
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          on: {
            init: function() {
              var self = this;
              setTimeout(function() {
                // *** CHANGED: use defaultSlideIndex instead of hard-coded 1 ***
                var targetIndex = defaultSlideIndex;
                // Force preview to the chosen slide (0 on mobile, 1 on desktop)
                if (self.params && self.params.loop && typeof self.slideToLoop === 'function') {
                  self.slideToLoop(targetIndex, 0);
                } else {
                  self.slideTo(targetIndex, 0);
                }
              }, 10);
            }
          }
        });

        swiperContainer.dataset.npSwiperInitialized = 'true';
        swiperContainer._npSwiper = swiperInstance;

        return swiperInstance;
      } catch (e) {
        console.error('Swiper initialization error (product card):', e);
        return null;
      }
    }

    // Always initialize Swiper for this card (even if no variants)
    initCardSwiper();

    // Detect variant UI / data
    var optionLists = card.querySelectorAll('.product-variant-picker-option');
    var scriptTag = card.querySelector('script.product-variants-data');

    var hasVariants =
      optionLists.length > 0 &&
      scriptTag &&
      typeof scriptTag.textContent === 'string' &&
      scriptTag.textContent.trim() !== '';

    // If NO variants: still keep slider, but ensure title/price/swatch stay visible
    if (!hasVariants) {
      card.dataset.npHasVariants = 'false';

      var titleEl = card.querySelector('.ProductItem__Title');
      var priceEl = card.querySelector('.product-price-text');
      var swatchEl = card.querySelector('.color-swatch');

      [titleEl, priceEl, swatchEl].forEach(function(el) {
        if (el) {
          el.style.display = 'block';
          el.style.opacity = '1';
        }
      });

      // No variant logic needed for single-variant products
      return;
    }

    // From here on, card has variants/options
    card.dataset.npHasVariants = 'true';

    var variantsData = safeJSONParse(scriptTag.textContent.trim());
    if (!variantsData) return;

    var variants = variantsData.variants || [];
    var totalOptions = optionLists.length;

    var selectedOptions = [];

    var firstList = card.querySelector('.product-variant-picker-option[data-option-index="0"]');
    if (!firstList) {
      firstList = optionLists[0];
    }
    if (!firstList) return;

    var firstOptionName = firstList.getAttribute('data-option-name') || '';
    var firstOptionIsColor = /color|farbe|colour|colore/i.test(firstOptionName);

    var findVariantForSelections = createVariantFinder(variants);

    /**
     * Update product images based on selected variant and sync with Swiper
     */
    function updateImagesForVariant(variantId) {
      if (!swiperContainer) return;

      var allSlides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
      var totalSlides = allSlides.length;
      if (totalSlides === 0) return;

      var featuredSlide = allSlides[totalSlides - 1];

      if (!variantId) {
        allSlides.forEach(function(slide) {
          slide.style.display = '';
        });
      } else {
        var variantIdStr = String(variantId);
        allSlides.forEach(function(slide) {
          var variantIds = slide.getAttribute('data-variant-ids') || '';
          var variantIdsArray = variantIds
            .split(',')
            .map(function(id) { return id.trim(); })
            .filter(Boolean);

          if (
            variantIdsArray.indexOf(variantIdStr) !== -1 ||
            variantIdsArray.length === 0 ||
            variantIds === ''
          ) {
            slide.style.display = '';
          } else {
            slide.style.display = 'none';
          }
        });
      }

      var instance = swiperInstance || (swiperContainer && swiperContainer.swiper);
      if (instance) {
        try {
          if (typeof instance.updateSlides === 'function') {
            instance.updateSlides();
          }
          instance.update();

          var firstVisibleIndex = -1;
          for (var i = 0; i < allSlides.length - 1; i++) {
            if (allSlides[i].style.display !== 'none') {
              firstVisibleIndex = i;
              break;
            }
          }

          if (firstVisibleIndex === -1 && featuredSlide && featuredSlide.style.display !== 'none') {
            firstVisibleIndex = totalSlides - 1;
          }

          if (firstVisibleIndex >= 0) {
            if (instance.params && instance.params.loop) {
              if (typeof instance.slideToLoop === 'function') {
                instance.slideToLoop(firstVisibleIndex, 0);
              } else {
                instance.slideTo(firstVisibleIndex, 0);
              }
            } else {
              instance.slideTo(firstVisibleIndex, 0);
            }
          }
        } catch (e) {
          console.error('Swiper update error:', e);
        }
      }
    }

    function updateOptionListForStep(list, optionIndex) {
      if (!list) return;

      var listItems = list.querySelectorAll('.HorizontalList__Item');
      if (!listItems.length) return;

      listItems.forEach(function(item) {
        var radio = item.querySelector('.SizeSwatch__Radio');
        if (!radio) return;

        var quickAddLink = item.querySelector('a[data-vari]');
        var optionValue = radio.value;
        var testSelections = selectedOptions.slice();
        testSelections[optionIndex] = optionValue;

        var variant = findVariantForSelections(testSelections);
        if (variant) {
          var isAvailable = !!variant.available;
          var variantIdStr = String(variant.id);

          item.className = item.className.replace(/\b\d+\b/g, '').trim();
          if (variantIdStr) item.classList.add(variantIdStr);
          item.classList.toggle('avail', isAvailable);

          var label = item.querySelector('.SizeSwatch');
          if (label) {
            label.classList.toggle('inactive', !isAvailable);
          }

          radio.setAttribute('data-variant-id', variantIdStr);
          radio.disabled = !isAvailable;

          if (isAvailable) {
            if (!quickAddLink) {
              quickAddLink = document.createElement('a');
              quickAddLink.setAttribute('data-vari', variantIdStr);
              quickAddLink.setAttribute('data-us', '');
              quickAddLink.setAttribute('data-gb', '');
              quickAddLink.setAttribute('data-eu', '');
              quickAddLink.setAttribute('data-currentcountry', 'EU');
              quickAddLink.setAttribute('data-title', optionValue);
              quickAddLink.textContent = 'QUICK ADD';
              item.insertBefore(quickAddLink, radio);
            } else {
              quickAddLink.setAttribute('data-vari', variantIdStr);
              quickAddLink.style.display = '';
            }
          } else if (quickAddLink) {
            quickAddLink.style.display = 'none';
          }

          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });

      var firstAvailable = list.querySelector('.SizeSwatch__Radio:not([disabled])');
      if (firstAvailable) {
        firstAvailable.checked = true;
        selectedOptions[optionIndex] = firstAvailable.value;
      }
    }

    function updateProductImage(optionValue) {
      if (!firstOptionIsColor || !optionValue) return;

      var safeValue = optionValue.replace(/"/g, '\\"');
      var firstRadio = firstList.querySelector('.SizeSwatch__Radio[value="' + safeValue + '"]');
      if (!firstRadio) return;

      var variantId = firstRadio.getAttribute('data-variant-id');
      if (!variantId) return;

      updateImagesForVariant(variantId);

      var variantImageUrl = firstRadio.getAttribute('data-variant-image');
      if (variantImageUrl) {
        var mainImages = card.querySelectorAll('.ProductItem__ImageWrapper img, .image-for-hover img');
        mainImages.forEach(function(img) {
          img.src = variantImageUrl;
          img.setAttribute('data-src', variantImageUrl);
        });
      }
    }

    // Initial selected values
    Array.from(optionLists).forEach(function(list, idx) {
      var checked = list.querySelector('.SizeSwatch__Radio:checked');
      if (checked) {
        selectedOptions[idx] = checked.value;
      }
    });

    // Core option selection logic (same for desktop and mobile)
    Array.from(optionLists).forEach(function(list) {
      var optionIndexAttr = list.getAttribute('data-option-index');
      var optionIndex = typeof optionIndexAttr === 'string'
        ? parseInt(optionIndexAttr, 10)
        : Array.from(optionLists).indexOf(list);
      if (isNaN(optionIndex)) optionIndex = Array.from(optionLists).indexOf(list);

      var isLastOption = optionIndex === totalOptions - 1;

      var radios = list.querySelectorAll('.SizeSwatch__Radio');
      radios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          var optionValue = this.value;
          selectedOptions[optionIndex] = optionValue;

          // First option image update
          if (optionIndex === 0) {
            if (firstOptionIsColor) {
              updateProductImage(optionValue);
            } else {
              var variantIdImg = this.getAttribute('data-variant-id');
              if (variantIdImg) {
                updateImagesForVariant(variantIdImg);
              }
            }
          }

          // Update price on card if variant is found
          var matchedVariant = findVariantForSelections(selectedOptions);
          if (matchedVariant && variantsData.formatted && variantsData.formatted[matchedVariant.id]) {
            var pData = variantsData.formatted[matchedVariant.id];
            var cardPriceEl = card.querySelector('.product-price-text');
            if (cardPriceEl) {
              if (pData.compare_at_price) {
                cardPriceEl.classList.add('has-sale-price');
                cardPriceEl.innerHTML = '<span class="price-item price-item--sale price--sale-highlight ProductItem__Price--sale" data-money-convertible="">' + pData.price + '</span>' +
                                        '<span class="price-item price-item--regular price--compare-at ProductItem__Price--compare" data-money-convertible="">' + pData.compare_at_price + '</span>';
              } else {
                cardPriceEl.classList.remove('has-sale-price');
                cardPriceEl.innerHTML = '<span class="ProductItem__Price Price Text--subdued" data-money-convertible="">' + pData.price + '</span>';
              }
            }
          }

          var nextOptionIndex = optionIndex + 1;
          var nextList = getNextOptionList(card, optionIndex);

          if (nextList && nextOptionIndex < totalOptions) {
            // There is another step (e.g., Size after Color)
            updateOptionListForStep(nextList, nextOptionIndex);

            // Show next list with proper animation, hide current list
            hideOptionList(list);
            showOptionList(nextList);
          } else {
            // LAST STEP → resolve variant & add to cart
            var variant = findVariantForSelections(selectedOptions);
            if (variant && variant.available) {
              ajaxAddToCart(variant.id).then(function() {
                // Close all option lists after successful add to cart
                hideAllOptionLists(card);
                card.classList.remove('is-hovered');
              });
            } else {
              console.warn('No available variant found for selections:', selectedOptions);
            }
          }
        });
      });

      // QUICK ADD behavior
      if (isLastOption) {
        list.addEventListener('click', function(e) {
          var quickAddLink = e.target && e.target.closest('a[data-vari]');
          if (!quickAddLink) return;
          e.preventDefault();
          var variantId = quickAddLink.getAttribute('data-vari');
          if (!variantId) return;

          ajaxAddToCart(variantId).then(function() {
            // Close all option lists after successful add to cart
            hideAllOptionLists(card);
            card.classList.remove('is-hovered');
          });
        });
      }
    });

    // Initialize next steps from first selection if present
    if (selectedOptions[0] && totalOptions > 1) {
      var secondList = getNextOptionList(card, 0);
      if (secondList) {
        updateOptionListForStep(secondList, 1);
      }
    }

    // Desktop hover behavior (variants only)
    if (!isMobile) {
      card.addEventListener('mouseenter', function() {
        hideAllOptionLists(card);
        showFirstOptionList(card);
        card.classList.add('is-hovered');

        var instance = swiperInstance || (swiperContainer && swiperContainer.swiper);
        if (instance && typeof instance.slideTo === 'function') {
          try {
            // *** CHANGED: use viewport-based default index instead of hard-coded 1 ***
            var targetIndex = isSliderMobileViewport() ? 0 : 1;
            // Reset to appropriate slide on hover
            if (instance.params && instance.params.loop && typeof instance.slideToLoop === 'function') {
              instance.slideToLoop(targetIndex, 0);
            } else {
              instance.slideTo(targetIndex, 0);
            }
          } catch (e) {
            console.error('Error resetting slider on hover:', e);
          }
        }
      });

      card.addEventListener('mouseleave', function() {
        hideAllOptionLists(card);
        card.classList.remove('is-hovered');
      });
    }

    // Plus icon behavior – always attach (but only makes sense when variants exist)
    var plusIcon = card.querySelector('.plus-icon');
    if (plusIcon) {
      plusIcon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var anyVisible = isAnyOptionListVisible(card);

        if (!anyVisible) {
          // OPEN: show only first option list with full styling
          hideAllOptionLists(card);
          showFirstOptionList(card);
          card.classList.add('is-hovered');

          var instance = swiperInstance || (swiperContainer && swiperContainer.swiper);
          if (instance && typeof instance.slideTo === 'function') {
            try {
              // *** CHANGED: use viewport-based default index here as well ***
              var targetIndex = isSliderMobileViewport() ? 0 : 1;
              if (instance.params && instance.params.loop && typeof instance.slideToLoop === 'function') {
                instance.slideToLoop(targetIndex, 0);
              } else {
                instance.slideTo(targetIndex, 0);
              }
            } catch (err) {
              console.error('Error resetting slider on plus click:', err);
            }
          }
        } else {
          // CLOSE: hide all lists
          hideAllOptionLists(card);
          card.classList.remove('is-hovered');
        }
      });
    }

    // Sync bottom color swatches with first option (if color)
    if (firstOptionIsColor) {
      var bottomColorSwatches = card.querySelectorAll('.color-swatch-new');
      if (bottomColorSwatches.length) {
        var firstListRadios = firstList.querySelectorAll('.SizeSwatch__Radio');
        bottomColorSwatches.forEach(function(swatch, index) {
          swatch.addEventListener('click', function(e) {
            e.preventDefault();
            var targetRadio = firstListRadios[index];
            if (targetRadio && !targetRadio.disabled) {
              targetRadio.checked = true;
              targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
              
              // On mobile, automatically show the next option list after color selection
              if (isMobile) {
                var nextList = getNextOptionList(card, 0);
                if (nextList) {
                  hideOptionList(firstList);
                  showOptionList(nextList);
                }
              }
            }
          });
        });
      }
    }
  }

  // Initialize all cards
  function initAllVariantPickers() {
    var cards = document.querySelectorAll('.product-new-grid-items');
    if (!cards.length) return 0;

    var initializedCount = 0;
    cards.forEach(function(card) {
      if (card.dataset.variantPickerInitialized === 'true') return;
      try {
        card.dataset.variantPickerInitialized = 'true';
        initVariantPicker(card);
        initializedCount++;
      } catch (e) {
        console.error('Error initializing variant picker for card:', e);
        card.dataset.variantPickerInitialized = '';
      }
    });
    return initializedCount;
  }

  function initCard(card) {
    if (!card || card.dataset.variantPickerInitialized === 'true') return false;
    try {
      card.dataset.variantPickerInitialized = 'true';
      initVariantPicker(card);
      return true;
    } catch (e) {
      console.error('Error initializing variant picker for card:', e);
      card.dataset.variantPickerInitialized = '';
      return false;
    }
  }

  // Global outside-click: close any open option lists (desktop + mobile)
  function attachOutsideClickListener() {
    if (npVariantOutsideListenerAttached) return;
    npVariantOutsideListenerAttached = true;

    document.addEventListener('click', function(e) {
      // Ignore clicks inside any product card or plus icon
      if (e.target.closest('.product-new-grid-items') || e.target.closest('.plus-icon')) {
        return;
      }

      var optionLists = document.querySelectorAll('.product-variant-picker-option');
      if (!optionLists.length) return;

      var hasVisible = false;
      optionLists.forEach(function(list) {
        if (list.style.display === 'flex') {
          hasVisible = true;
        }
      });
      if (!hasVisible) return;

      optionLists.forEach(function(list) {
        hideOptionList(list);
      });

      var cards = document.querySelectorAll('.product-new-grid-items.is-hovered');
      cards.forEach(function(card) {
        card.classList.remove('is-hovered');
      });
    });
  }

  // Expose helpers
  window.npInitVariantPicker = initVariantPicker;
  window.npInitAllVariantPickers = initAllVariantPickers;
  window.npInitCard = initCard;

  function runInit() {
    if (typeof Swiper === 'undefined') {
      setTimeout(runInit, 100);
      return;
    }

    initAllVariantPickers();
    attachOutsideClickListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    setTimeout(runInit, 0);
  }

  // MutationObserver: catch cards added later with a debounce to prevent O(n²) queries
  if (typeof MutationObserver !== 'undefined') {
    var observerTimer = null;
    var observer = new MutationObserver(function() {
      if (observerTimer) clearTimeout(observerTimer);
      observerTimer = setTimeout(initAllVariantPickers, 50);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Theme editor support
  if (typeof document.addEventListener !== 'undefined') {
    document.addEventListener('shopify:section:load', function(event) {
      var container = event.target;
      if (!container || !container.querySelectorAll) return;
      var cards = container.querySelectorAll('.product-new-grid-items');
      cards.forEach(function(card) {
        card.dataset.variantPickerInitialized = '';
        initCard(card);
      });
    });

    document.addEventListener('shopify:section:reorder', function() {
      setTimeout(initAllVariantPickers, 100);
    });

    document.addEventListener('shopify:section:select', function() {
      setTimeout(initAllVariantPickers, 100);
    });
  }
})();
